<template>
  <div>
    <div class="card" v-if="loading">
      <b-loading
        :is-full-page="true"
        :active="loading"
        :can-cancel="true"
      ></b-loading>
    </div>

    <div class="card has-text-centered box px-6 py-4">
      <div v-if="proceed == false" class="card-content">
        <H1 class="is-size-3">Traveling with a guest?</H1>
        <H1 class="is-size-5 py-2"
          >Do you wish to add an additional traveler to this flight?</H1
        >

        <div class="mt-4">
          <b-button
            label="No, proceed without guest"
            outlined
            size="is-medium"
            class="mr-2 mt-2"
            @click="skipAndClose"
          />
          <b-button
            label="Yes, add a guest"
            type="is-primary"
            size="is-medium"
            class="mr-2 mt-2"
            @click="proceed = true"
          />
        </div>
      </div>

      <div v-if="proceed == true" class="card-content">
        <div v-if="selectedGuest === null">
          <H1 class="is-size-5 py-2"
            >Select a guest from the dropdown menu below or create a new
            profile:</H1
          >

          <b-dropdown v-model="proposedGuest" aria-role="list">
            <template #trigger>
              <b-button
                :label="
                  proposedGuest
                    ? proposedGuest.firstName + ' ' + proposedGuest.lastName
                    : 'Create new guest profile'
                "
                type="is-info"
                icon-left="account-multiple"
                icon-right="menu-down"
                size="is-medium"
                outlined
              />
            </template>

            <b-dropdown-item
              v-for="option in guests"
              :value="option"
              :key="option.value"
              aria-role="listitem"
              class="is-block"
            >
              <div class="media has-text-left">
                <b-icon class="media-left" icon="account"></b-icon>
                <div class="media-content">
                  <h3>{{ option.firstName + " " + option.lastName }}</h3>
                </div>
              </div>
            </b-dropdown-item>

            <b-dropdown-item :value="null" aria-role="listitem">
              <div class="media">
                <b-icon class="media-left" icon="account-plus-outline"></b-icon>
                <div class="media-content">
                  <h3>Create new guest profile</h3>
                </div>
              </div>
            </b-dropdown-item>
          </b-dropdown>

          <div v-if="proposedGuest != null" class="mt-6">
            <b-button
              label="Back"
              outlined
              size="is-medium"
              class="mr-2"
              @click="proceed = false"
            />

            <b-button
              label="Continue"
              size="is-medium"
              type="is-primary"
              @click="selectedGuest = proposedGuest"
            />
          </div>

          <!-- CREATE PROFILE FORM -->

          <div v-if="proposedGuest == null" aria-id="contentIdForA11y1">
            <div class=" p-5 m-5 ">
              <section class="" style="min-height: 12rem;">
                <div class="columns">
                  <div class="column">
                    <b-field label="First Name" label-position="on-border">
                      <b-input v-model="formData.firstName"></b-input>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="Middle Name" label-position="on-border">
                      <b-input v-model="formData.middleName"></b-input>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="Last Name" label-position="on-border">
                      <b-input v-model="formData.lastName"></b-input>
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <b-field label="Gender" label-position="on-border">
                      <b-select
                        v-model="formData.gender"
                        placeholder="Select Gender"
                        required
                        expanded
                      >
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Non-Binary">Non-Binary</option>
                      </b-select>
                    </b-field>
                  </div>
                  <div class="column">
                    <b-field label="Date of Birth" label-position="on-border">
                      <b-input
                        v-model="formData.dob"
                        placeholder="mm/dd/yyyy"
                        v-cleave="masks.dob"
                      ></b-input>
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <b-field label="Email" label-position="on-border">
                      <b-input
                        value=""
                        v-model="formData.email"
                        icon="email"
                      ></b-input>
                    </b-field>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <b-field label="Cell Phone" label-position="on-border">
                      <b-input
                        type="tel"
                        name="phone"
                        v-model="formData.cell"
                        v-cleave="masks.phone"
                        icon="phone"
                      ></b-input>
                    </b-field>
                  </div>
                </div>
                <div class="columns py-4">
                  <div class="column">
                    <b-notification
                      v-if="saveError !== ''"
                      type="is-danger"
                      aria-close-label="Close notification"
                      role="alert"
                    >
                      {{ saveError }}
                    </b-notification>

                    <div v-if="inputErrors" style="color: red">
                      <li
                        class="is-size-7"
                        style="padding-left: 10px;"
                        v-for="message in inputErrors"
                        :key="`D ${message}`"
                      >
                        {{ message }}
                      </li>
                    </div>
                  </div>
                </div>
              </section>

              <b-button
                size="is-medium"
                label="Cancel"
                class="mr-2"
                @click="proceed = false"
              />

              <b-button
                label="Save Profile"
                @click="checkInputs"
                type="is-primary"
                size="is-medium"
              />
            </div>
          </div>
        </div>

        <div v-if="selectedGuest !== null">
          <div class="is-size-3">Confirm Guest Booking</div>

          <div class="is-size-5 py-5">
            Add
            <b>{{ selectedGuest.firstName + " " + selectedGuest.lastName }}</b>
            to the following itinerary?
          </div>

          <div
            v-for="(leg, index) in flightInfo.journeys"
            :key="index"
            class="mb-3 has-text-left"
          >
            <div class="columns is-mobile">
              <div class="column is-2 is-mobile">
                <img
                  width="25"
                  :src="$helpers.airlineLogo(leg.airlineCode, 100, 100)"
                  class="mt-1"
                />
              </div>
              <div class="column is-10">
                <div
                  class="columns is-mobile is-gapless"
                  style="margin-bottom:8px"
                >
                  <div class="column is-narrow">
                    <div class="has-text-weight-bold">
                      {{ leg.from }}
                    </div>
                    <div class="is-size-7 has-text-grey">
                      {{ getAirportLocation(leg.from) }}
                    </div>
                  </div>
                  <div class="column is-narrow">
                    <span class="is-size-7 mt-2 px-2 is-block">
                      <b-icon
                        icon="arrow-right"
                        class="has-text-grey-light"
                      ></b-icon>
                    </span>
                  </div>
                  <div class="column is-narrow">
                    <div class="has-text-weight-bold">
                      {{ leg.to }}
                    </div>
                    <div class="is-size-7 has-text-grey">
                      {{ getAirportLocation(leg.to) }}
                    </div>
                  </div>
                </div>

                <span class="is-size-6 has-text-grey-light">{{
                  leg.legs[0].departingAt.date | formatDate
                }}</span>
                <br />
                <div class="is-size-6">
                  {{ leg.legs[0].departingAt.time | formatTime }} -
                  {{ leg.legs.slice(-1).pop().arrivingAt.time | formatTime }}
                </div>
              </div>
            </div>
          </div>

          <b-notification
            v-if="confirmError !== ''"
            type="is-danger"
            role="alert"
          >
            {{ confirmError }}
          </b-notification>

          <b-button
            label="Back"
            type="is-outline"
            size="is-medium"
            class="mr-2 mt-2"
            @click="cancelGuest"
          />

          <b-button
            label="Confirm guest flight"
            type="is-primary"
            size="is-medium"
            class="mt-2"
            @click="addGuestToFlight"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cleave from "cleave.js";
import SmallFlightItinerary from "@/components/Itinerary/SmallFlightItinerary.vue";
import meetingsMixin from "@/mixins/meetingsMixin";
import moment from "moment";

//require("cleave.js/dist/addons/cleave-phone.ca");
//var moment = require("moment"); // require
// import CleavePhone from 'cleave.js/dist/addons/cleave-phone.i18n';
const cleave = {
  name: "cleave",
  bind(el, binding) {
    const input = el.querySelector("input");
    input._vCleave = new Cleave(input, binding.value);
  },
  unbind(el) {
    const input = el.querySelector("input");
    input._vCleave.destroy();
  },
};

export default {
  directives: { cleave },
  name: "AddMeetingGuest",
  mixins: [meetingsMixin],
  components: {
    //SmallFlightItinerary,
  },
  props: {},
  data: function() {
    return {
      isOpen: 0,
      saveError: "",
      confirmError: "",
      proceed: false,
      showForm: false,
      dependentTravellers: [],
      loading: false,
      proposedGuest: null,
      selectedGuest: null,
      guests: [],
      formData: {
        firstName: "",
        lastName: "",
        middleName: "",
        gender: "",
        dob: "",
        email: "",
        cell: "",
        policyId: "",
      },
      masks: {
        creditCard: { creditCard: true },
        numeral: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
          prefix: "$ ",
        },
        date: {
          date: true,
          datePattern: ["m", "y"],
        },
        dob: {
          date: true,
          delimiter: "/",
          datePattern: ["m", "d", "Y"],
        },
        phone: {
          phone: true,
          phoneRegionCode: "US",
          delimiter: "-",
        },
      },
      inputErrors: false,
      newTravelerResult: [],
    };
  },
  computed: {
    solution() {
      return this.$store.state.bookTravel.result;
    },
    profile() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ];
    },
    flightInfo() {
      return this.$store.state.bookTravel.result.flight;
    },
    meetingAttendeeId() {
      return this.$store.state.meetings.meetingInfo.attendeeId;
    },
  },
  methods: {
    onInput(event) {
      this.rawValue = event.target._vCleave.getRawValue();
      this.value = event.target._vCleave.getFormattedValue();
    },
    checkInputs() {
      let messages = [];

      if (!this.formData.firstName) {
        messages.push("Please add guest's First Name");
      }
      if (!this.formData.lastName) {
        messages.push("Please add guest's Last Name");
      }
      if (!this.formData.gender) {
        messages.push("Please select Gender");
      }
      if (!this.formData.email) {
        messages.push("Please add guest's Email");
      }
      if (!this.formData.dob) {
        messages.push("Please add guest's date of birth");
      }
      if (!this.formData.cell) {
        messages.push("Please add guest's Cell Phone");
      }

      if (messages.length > 0) {
        this.inputErrors = messages;
      } else {
        // console.log('proceed with traveler')
        this.saveForm();
      }
    },
    async getMyTravelers() {
      let body = {
        contactId: this.profile.id,
      };

      let result = await this.$app.huddleLabsServerCall(
        "profile/meeting-guests",
        body
      );

      if (result.data?.length > 0) {
        this.guests = result.data;
      }
    },
    async saveForm() {
      this.saveError = "";
      this.loading = true;
      var dob = this.formData.dob;
      var newDate = moment(dob, "MM-DD-YYYY").format("YYYY-MM-DD");

      var body = {
        currentUser: {
          contactId: this.profile.id,
        },
        meetingAttendeeId: this.meetingAttendeeId,
        traveler: {
          isGuest: true,
          firstName: this.formData.firstName,
          lastName: this.formData.lastName,
          middleName: this.formData.middleName,
          email: this.formData.email,
          mobilePhone: this.formData.cell,
          gender: this.formData.gender,
          dateOfBirth: newDate,
          //travelPolicyId: this.formData.policyId,
        },
      };

      let result = await this.$app.huddleLabsServerCall(
        "profile/meeting-guests/create",
        body
      );

      this.loading = false;

      if (result.data) {
        //add new guest to guests array and set as designated guest
        this.guests.push(result.data);
        this.selectedGuest = this.proposedGuest = result.data;
      } else {
        this.loading = false;
        console.log(result);
        if (result.errors) this.saveError = result.errors[0];
        else
          this.saveError =
            "An error occured and we were unable to save the traveler profile.";
      }
    },
    async addGuestToFlight() {
      this.confirmError = "";
      //Copy flight details from primary passenger's solution
      let solution = {};
      solution.flight = this.$store.state.bookTravel.result.flight;

      let request = {
        meetingAttendeeId: this.meetingAttendeeId,
        guestContactId: this.selectedGuest.id,
      };

      let result = await this.$app.huddleLabsServerCall(
        "profile/meeting-guests/associate-to-meeting-attendee",
        request
      );

      if (result.data) {
        let meetingAttendeeGuestId = result.data.Id;
        let payload = {
          profile: this.selectedGuest,
          solution: solution,
          meetingAttendeeGuestId: meetingAttendeeGuestId,
        };

        this.$store.commit("bookTravel/ADD_GUEST_TRIP", payload);

        this.$parent.close();
        this.meetingRouter();
      } else if (result.errors.length > 0) {
        this.confirmError = result.errors[0].title;
      }
    },
    cancelGuest() {
      this.selectedGuest = null;
    },
    skipAndClose() {
      //close modal and go to next step in the meeting booking flow
      this.$parent.close();
      this.meetingRouter();
    },
    getAirportLocation(airportCode) {
      let airport = this.$globals.airports.find(
        ({ code }) => code == airportCode
      );
      if (!airport) return null;
      return airport.city + ", " + airport.state;
    },
  },
  async mounted() {
    this.$forceUpdate();

    await this.getMyTravelers();

    if (this.guests.length > 0) {
      this.proposedGuest = this.guests[0];
    }
  },
};
</script>

<style scoped></style>
